import {Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class ClienteOportunidadeService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Oportunidade por id
     * @param id ID da Oportunidade
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "clientes/oportunidades/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Oportunidade
     * @param id ID da Oportunidade
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/oportunidades"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Oportunidade
     * @param id ID da Oportunidade
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "clientes/oportunidades/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Oportunidade
     * @param params Json Oportunidade
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "clientes/oportunidades", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Oportunidade
     * @param params Json Oportunidade
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "clientes/oportunidades/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Exporta Lista em Excel
     * @param id ID
     */
    getAllExport(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";

        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }
        return this._http.get(this.utilitesService.urlPrefix + "clientes/oportunidades/export" + env, {
            responseType: "arraybuffer",
            headers: new HttpHeaders({
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "Authorization": "Bearer " + this.authService.getToken(),
                "Access-Control-Allow-Origin": "*"
            })
        });
    }  

}
